import { connect } from 'react-redux'

import { CAN_INPUT } from 'utils/constants'
import { isUndefined } from 'utils/types'

import { makeAffinityGroupSelector } from 'selectors/feature/affinityGroups'
import { makeGetPinCircuit } from 'selectors/feature/harnesses'

import { getIsSixteenBitCanOutput } from 'selectors/feature/outputs'
import {
  getInputSignalSwitches,
  makeSignalSelector,
} from 'selectors/feature/inputs'

import {
  getFeatureModuleName,
  getFeatureType,
} from 'selectors/feature/featureMetadata'
import ReadOnly from './ReadOnly'

const makeMapStateToProps = () => {
  const affinityGroupSelector = makeAffinityGroupSelector()
  const getPinCircuit = makeGetPinCircuit()
  const currentSignalSelector = makeSignalSelector()

  return (state, ownProps) => {
    const {
      uri,
      parentQueryUri,
      withBitTable: initialWithBitTable,
      operator,
      edge,
      hysteresis,
      value,
      valueMin,
      valueMax,
      inputAssertion,
      signal,
      parentType,
      inputUri,
      selectedInputDescription,
      fnId,
      numberOfBits,
      startBit,
      canId,
      inputConfig,
      units,
      translations,
      translationType,
      connector,
      location,
      switchNumber,
      subType,
      customDescription,
    } = ownProps

    const isSingleCondition = !parentQueryUri

    const isSixteenBitCanOutput = getIsSixteenBitCanOutput(state, { id: fnId })

    const moduleName = getFeatureModuleName(state)
    const pinLocation = `${moduleName}-${connector}-${location}`
    const currentSignal = currentSignalSelector(state, { signal: inputUri })
    const { interfacePins = null } = currentSignal

    const withBitTable = !isUndefined(initialWithBitTable)
      ? initialWithBitTable
      : subType && subType.includes(CAN_INPUT)

    const { affinityGroupNumber, highlightAffinity } =
      affinityGroupSelector(state, { id: inputUri }) || {}

    const circuit = getPinCircuit(state, { id: inputUri })
    const featureType = getFeatureType(state)
    const currentSignalSwitches = getInputSignalSwitches(state, {
      signal: inputUri,
    })
    return {
      featureModuleName: moduleName,
      selectedInputDescription,
      inputConfig,
      parentType,
      uri,
      parentQueryUri,
      inputUri,
      operator,
      edge,
      hysteresis,
      value,
      valueMin,
      valueMax,
      inputAssertion,
      affinityGroupNumber,
      highlightAffinity,
      signal,
      fnId,
      numberOfBits,
      startBit,
      canId,
      units,
      withBitTable,
      isSingleCondition,
      translations,
      translationType,
      isSixteenBitCanOutput,
      pinLocation,
      switchNumber,
      circuit,
      featureType,
      subType,
      currentSignalSwitches,
      interfacePins,
      customDescription,
    }
  }
}

export default connect(makeMapStateToProps)(ReadOnly)
